/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Wiki_BackInputs */



/**

* @param {_Wiki_BackInputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
export const _wiki_back = /** @type {((inputs?: _Wiki_BackInputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Wiki_BackInputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return /** @type {LocalizedString} */ ("Zurück")
});